export function bytesToMegaBytes(bytes: number): number {
  return bytes / (1024 * 1024);
}